import { Injectable } from '@angular/core';

@Injectable()
export class JiraDashboardService {
    public projectNames: Array<string> = ['SL'];
    public url: string = '/api/dashboard/getJiraIssues';
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/dashboards/jira-dashboard.service.ts